export default function getStaticFile(fileName) {
    return `${window.ENV.STATIC_ROOT}${fileName}`;
}